export default {
  // getLearningInfo: (state) => {
  //     return state.learningInfo
  // }
  getIsBookingNoRegistration: (state) => {
    return state.IsBookingNoRegistration
  },
  getIsSettingsNoRegistration: (state) => {
    return state.isSettingsNoRegistration
  },
};
